import WistiaVideo from './wistiaVideo'

export default WistiaVideo